module.exports = __webpack_public_path__ + "img/运动活动-1@2x.623f7f49.png";